<script lang="ts" setup>
import { useValidator } from '@/composeables';
import type { ValidatorDef } from '@/objects/gui/ValidatorDef';
import type { IInputTextModelModifiersInProps } from './PropInterfaces';
import type { AlertMessageType } from '@/objects';
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        value: string | null;
        validator?: ValidatorDef | null;

        /**
         * The modifier for the display
         * TODO: Should this have a model and this be named modelModifiers?
         * Practically you cant do a modifier in markup the way this is implemented now.
         * @default undefined
         */
        modifier?: IInputTextModelModifiersInProps;
    }>(),
    { value: null, modifier: undefined },
);

const { ValidateMessage } = useValidator(props.validator ?? null, props.value);

const applyModifier = (value: string | null) => {
    if (!props.modifier || value === null) {
        return value;
    }

    if (props.modifier.uppercase) {
        return value.toUpperCase();
    } else if (props.modifier.lowercase) {
        return value.toLowerCase();
    } else if (props.modifier.capitalize) {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }
    return value;
};

const computedStatus = computed(() => {
    if (!ValidateMessage) {
        return null;
    }
    return ValidateMessage.value?.type ?? null;
});

defineExpose({
    CellStatus: computedStatus,
});
</script>

<template>
    <div
        class="field-renderer-text"
        :class="[ValidateMessage != null ? 'alert-' + ValidateMessage.type : '']"
    >
        {{ applyModifier(value) }}
    </div>
</template>
